import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function DonationCancel() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar showAnnouncement={false} />
      <section className="pt-32 pb-24 max-w-2xl mx-auto px-6 lg:px-10 text-center" data-testid="donation-cancel-page">
        <XCircle className="mx-auto text-slate-400" size={56} strokeWidth={1.5} />
        <h1 className="mt-8 font-display text-4xl md:text-5xl font-medium tracking-tighter text-slate-900">
          Payment cancelled.
        </h1>
        <p className="mt-5 text-lg text-slate-600 leading-relaxed">
          No charge was made. If this was unintentional, you can pick up where you left off.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/donate" className="btn-primary" data-testid="cancel-retry">Try again</Link>
          <Link to="/" className="btn-outline-light">Back to home</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
